let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gEVrP")).then(() => parcelRequire('lTK0k'));